import { t } from '../i18n';
// admin-client/src/components/FeeSlider.jsx
import React from 'react';
import PropTypes from 'prop-types';
export default function FeeSlider({ value = 0, // 0~100 (상대 퍼센트)
min = 0, max = 100, step = 1, disabled = false, onChange, // (number) => void
onChangeEnd, // (number) => void (blur/mouseup/Enter)
showValue = true, // withInput=false 일 때만 의미 있음
label = t("\uBD84\uBC30 \uBE44\uC728"), withInput = true, // 🔹 직접 입력 박스 표시 여부(기본 ON)
 }) {
    // 안전 값
    const clamp = (n) => Math.min(max, Math.max(min, n));
    const snap = (n) => {
        const x = Number(n);
        if (!Number.isFinite(x))
            return clamp(0);
        if (!(Number.isFinite(step) && step > 0))
            return clamp(x);
        const snapped = Math.round((x - min) / step) * step + min;
        return clamp(Number(snapped.toFixed(6))); // 부동소수 오차 방지
    };
    const v = clamp(Number(value) || 0);
    // 🔹 텍스트 입력용 드래프트 상태 (사용자 타이핑 보존)
    const [draft, setDraft] = React.useState(String(v));
    // 외부 value 변경 시 입력창 동기화
    React.useEffect(() => {
        setDraft(String(v));
    }, [v]);
    // 슬라이더 움직이는 동안 (실시간)
    const handleSliderInput = (e) => {
        const n = snap(Number(e.target.value));
        setDraft(String(n));
        onChange?.(n);
    };
    // 슬라이더 놓는 시점 확정
    const handleSliderCommit = (e) => {
        const n = snap(Number(e.target.value));
        setDraft(String(n));
        onChangeEnd?.(n);
    };
    // 텍스트 입력 중 (실시간) — 숫자로 변환 가능한 경우에만 onChange
    const handleTextInput = (e) => {
        const raw = e.target.value;
        setDraft(raw);
        const n = Number(raw);
        if (Number.isFinite(n)) {
            const s = snap(n);
            onChange?.(s);
        }
    };
    // 텍스트 입력 확정(blur/Enter)
    const commitText = () => {
        const n = Number(draft);
        const s = Number.isFinite(n) ? snap(n) : v; // 숫자 아니면 기존값 유지
        setDraft(String(s));
        onChangeEnd?.(s);
    };
    const handleTextKeyDown = (e) => {
        if (e.key === 'Enter')
            commitText();
    };
    return (<div className="w-full">
      <div className="mb-2 flex items-center justify-between text-sm">
        <span className="text-gray-600">{label}</span>

        {withInput ? (<div className="flex items-center gap-1">
            <input type="number" inputMode="decimal" min={min} max={max} step={step} value={draft} disabled={disabled} onChange={handleTextInput} onBlur={commitText} onKeyDown={handleTextKeyDown} className="
                w-20 px-2 py-1 rounded-md border border-gray-300
                focus:outline-none focus:ring-2 focus:ring-black/40
                text-right tabular-nums
              "/>
            <span className="text-gray-500">%</span>
          </div>) : (showValue && (<span className="font-medium tabular-nums">{v.toFixed(2)}%</span>))}
      </div>

      {/* native range + 간단 스타일 */}
      <input type="range" min={min} max={max} step={step} value={v} disabled={disabled} onInput={handleSliderInput} onChange={handleSliderInput} onMouseUp={handleSliderCommit} onTouchEnd={handleSliderCommit} onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && handleSliderCommit(e)} className="
          w-full accent-black
          [--tw-shadow:0_0_0_0_rgba(0,0,0,0)]
          focus:outline-none
        "/>

      {/* 트랙 시각 보조 */}
      <div className="mt-2 h-2 w-full rounded-full bg-gray-200 relative overflow-hidden">
        <div className="absolute left-0 top-0 h-full bg-black" style={{ width: `${((v - min) / (max - min || 1)) * 100}%` }}/>
      </div>

      <div className="mt-1 flex justify-between text-[11px] text-gray-500">
        <span>{min}%</span>
        <span>{max}%</span>
      </div>
    </div>);
}
FeeSlider.propTypes = {
    value: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onChangeEnd: PropTypes.func,
    showValue: PropTypes.bool,
    label: PropTypes.string,
    withInput: PropTypes.bool, // 🔹 추가
};
